import { createMuiTheme } from "@material-ui/core/styles";

const leagueThemes = {
  // NBA
  "00": {
    primary: {
      main: "#1d428a",
      dark: "#172b5b",
      light: "#4a6fb3",
    },
    league: {
      icon: "#24428A",
      tileBg: "rgba(29, 66, 138, 0.75)",
      tileBgActive: "rgba(29, 66, 138, 0.40)",
    },
    action: {
      selected: "#e3ebfe",
    },
    header: {
      background: "#000",
      color: "#ffffff",
      highlightBorder: "#c8102e",
      menuLabel: "#b5b5b5",
    },
    headerText: {
      fontFamily: '"Action NBA  Web" !important',
      fontSize: "1.8rem",
      mobileHeaderText: "1.1rem",
    },
    loader: {
      bottom: "blue",
      top: "red",
      text: "#000000",
    },
    highlightedMenu: {
      borderBottom: "3px solid #c8102e",
    },
    fontStyle: {
      fontFamily: '"Action NBA  Web" !important',
      smFontWeight: '100 !important',
      mdFontWeight: '300 !important',
      mdfontSize: '1.5rem',
    },
    h5fontSizeteamName: {
      fontSize: "1.5rem",
      mobilefontSize: "1.35rem",
    },
    h4fontSizeTeamSlider: {
      fontSize: "2.125rem",
    },
    matchCenterfontSize: {
      fontSize: "1.1rem",
      lineHeight: "1",
    },
    headerBarText: {
      appNameSize: "3rem",
      subTitleSize: "1.25rem",
      mobileappNameSize: "2.8rem",
      mobilesubTitleSize: "1rem",
    },
    teamTileBackground: { background: "rgb(87, 87, 87, 50%) !important" },
  },

  // WNBA
  10: {
    primary: {
      main: "#000",
      dark: "#000",
      light: "#FA4D00",
    },
    league: {
      icon: "#636363",
      tileBg: "#636363",
      tileBgActive: "rgba(99, 99, 99, 0.7)",
      titleColor: "#FA4D00",
    },
    action: {
      selected: "rgba(145, 145, 145, 0.20)",
    },
    header: {
      background: "#000",
      color: "#FA4D00",
      highlightBorder: "#FA4D00",
      menuLabel: "#b5b5b5",
    },
    headerText: {
      fontFamily: '"wnbaextended_black" !important',
      fontSize: "1.05rem",
      mobileHeaderText: "0.8rem",
    },
    loader: {
      bottom: "#000",
      top: "#FA4D00",
      text: "#ffffff",
    },
    highlightedMenu: {
      borderBottom: "3px solid #FA4D00",
    },
    fontStyle: {
      fontFamily: '"Roboto", sans-serif !important',
      fontWeight: '500 !important',
      mdFontWeight: '500 !important',
      mdfontSize: '1.2rem',
    },
    h5fontSizeteamName: {
      fontSize: "1rem",
      mobilefontSize: "1rem",
    },
    h4fontSizeTeamSlider: {
      fontSize: "1.2rem",
    },
    matchCenterfontSize: {
      fontSize: "0.9rem",
      lineHeight: "normal",
    },
    headerBarText: {
      appNameSize: "1.7rem",
      subTitleSize: "0.8rem",
      mobileappNameSize: "1.1rem",
      mobilesubTitleSize: "0.46rem",
      mdappNameSize: "1.5rem",
      mdsubTitleSize: "0.7rem",
    },
    teamTileBackground: {
      background: "rgb(174, 169, 169, 50%) !important",
    },
  },
};

export const useLeagueTheme = (leagueId, paletteType = "light") => {
  if (!leagueId) return null;

  const leagueTheme = leagueThemes[leagueId];

  if (!leagueTheme) {
    console.warn("Unknown leagueId:", leagueId);
    return null;
  }

  return createMuiTheme({
    palette: {
      type: paletteType,
      primary: leagueTheme.primary,
      league: leagueTheme.league,
      action: leagueTheme.action,
      header: leagueTheme.header,
      loader: leagueTheme.loader,
      highlightedMenu: leagueTheme.highlightedMenu,
      fontStyle: leagueTheme.fontStyle,
      h5fontSizeteamName: leagueTheme.h5fontSizeteamName,
      h4fontSizeTeamSlider: leagueTheme.h4fontSizeTeamSlider,
      matchCenterfontSize: leagueTheme.matchCenterfontSize,
      headerText: leagueTheme.headerText,
      headerBarText: leagueTheme.headerBarText,
      teamTileBackground: leagueTheme.teamTileBackground,
      background: {
        paper: "#ffffff",
      },
    },
  });
};
